<template>
  <v-snackbar
    v-model="show"
    :color="colorMsg"
    timeout="-1"
    :bottom="alignX === 'bottom'"
    :right="alignY === 'right'"
    :left="alignY === 'left'"
  >
    {{ textError }}
  </v-snackbar>
</template>

<script>
const props = {
  message: {
    default: "Error general",
    type: String,
  },
  onFinish: Function,
  show: {
    default: false,
    type: Boolean,
  },
  colorMsg: {
    default: "error",
    type: String,
  },
  time: {
    default: 2500,
    type: Number,
  },
  alignX: {
    default: "bottom",
    type: String,
  },
  alignY: {
    default: "right",
    type: String,
  },
};

export default {
  data: () => ({
    codeError: [
      "GENERAL_ERROR",
      "RECORDS_MISMATCH",
      "RECORDS_NOT_EXISTS",
      "RECORD_NOT_EXIST",
      "NO_RECORDS",
      "CORRUPTED_DATA",
      "INVALID_DATA",
      "INVALID_PASSWORD",
      "DUPLICATE_RECORD",
      " REQUIRED_FIELDS",
      "EXPIRED_CONTENT",
      "USER_WRONG_CREDENTIALS",
      "USER_NOT_EXISTS",
      "USER_ALREADY_EXISTS",
      " USER_UPDATE_NO_IDS",
      "USER_UPDATE_EMAIL_NOT_UNIQUE",
      "USER_REGISTER_MISSING_REQUIRED_FIELDS",
      "FACEBOOK_LOGIN_GRAPH_API_USER_INFO_ERROR",
      "TWILIO_SMS_SEND_VERIFICATION_CODE_ERROR",
      "SMS_VERIFY_NOT_VALIDATED_CODE",
      "SMS_VERIFY_INVALID_CODE",
      "SMS_VERIFY_ALREADY_VERIFIED",
      "SMS_VERIFY_TOO_MANY_ATTEMPTS",
      "CELL_NOT_EXISTS",
      "CLIENT_NOT_EXISTS",
      "VALIDATION_ERROR",
      "UNAUTHORIZED_ACTION",
      "TRIP_NOT_EXISTS",
      "CLIENT_CODE_NOT_EXISTS",
      "CSV_NO_DATA",
      "CLIENTS_NOT_FOUND",
      "INVALID_INPUT",
      "NO_ACTION",
      "UNAUTHORIZED ACTION",
      "INTERNET_DISCONNECTED",
      "NO_FILTTER",
      "UNAUTHORIZED_ACCESS",
      "EXCEL_PROCESSING_LINE_ERROR",
      "UNDEFINED_FILE_ERROR",
    ],
    msgError: [
      "Error general",
      "Hay un numero de registros distintos",
      "Los registros no existen",
      "El registro no existe",
      "No hay resultados",
      "Información invalida",
      "Información invalida",
      "Contraseña no válida",
      "El registro ya existe",
      "Favor de revisar todos los campos necesarios.",
      "La solicitud ha caducado",
      "El usuario o contraseña son incorrectos",
      "El usuario no existe",
      "El usuario ya existe",
      "Falta información para procesar la solicitud",
      "El email proporcionado ya existe",
      "Falta información para procesar la solicitud",
      "Error al ingresar con Facebook, intente más tarde",
      "Error al enviar el SMS, intente más tarde",
      "El código no ha sido validado",
      "El código proporcionado no es válido.",
      "El telefono fue ya verificado",
      "Ha superado el límite de mensajes, inténtelo más tarde",
      "La célula no existe",
      "La empresa no existe",
      "Algunos campos no son validos",
      "Elusuario no tiene permisos para ejecutar la acción",
      "El viaje no existe",
      "El código de empresa no existe",
      "No existen datos para la descarga",
      "No se encontraron clientes",
      "Algunos campos son inválidos",
      "No se pudo realizar la accion",
      "El usuario no tiene permisos para ejecutar la acción",
      "Revisé su conexión a internet",
      "Ingrese los filtros",
      "No tiene permiso de acceso",
      "El archivo tiene problemas en la línea",
      "Error desconocido favor de validar el archivo.",
    ],
    textError: "",
  }),
  updated: function() {
    this.$nextTick(function() {
      if (this.message != "Error general") {
        for (let i = 0; i < this.codeError.length; i++) {
          if (this.message == this.codeError[i]) {
            this.textError = this.msgError[i];
          } else if (this.codeError[37] === this.message.substring(0, 27)) {
            this.textError =
              this.msgError[37] + " " + this.message.substring(27, 40) + ".";
          }
        }
      } else {
        this.textError = this.message;
      }
      setTimeout(() => {
        this.$emit("show");
        if (this.onFinish) {
          this.onFinish();
        }
      }, this.time);
    });
  },
  methods: {
    Change(prop) {
      this.$emit("v-model", prop);
    },
  },
  props: props,
};
</script>

<style scoped></style>
